// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:720px){.title[data-v-381d9147]{font-weight:700}.text[data-v-381d9147],.title[data-v-381d9147]{color:var(--color-white);margin-right:4px;word-break:break-word}.link[data-v-381d9147],.text[data-v-381d9147],.title[data-v-381d9147]{font-size:var(--font-size-micro)}.link[data-v-381d9147]{color:var(--color-main);text-decoration:underline}}", ""]);
// Exports
module.exports = exports;
